export default __webpack_public_path__ + "static/media/64_desktop.fd74bd93.jpg";